import { normalizeLocale } from "@/lib/i18n";
import { translate } from "@/lib/i18n-dict";

/**
 * Localizes a route's static SEO title/description for head().
 * Route params only carry the optional {-$locale} segment.
 */
export function localeMeta(params: unknown, title: string, description: string) {
  const locale = normalizeLocale((params as { locale?: string } | undefined)?.locale);
  return {
    locale,
    title: translate(locale, title),
    description: translate(locale, description),
  };
}
